<template>

  <div :class="s.modalContent">
          <div :class="s.title">
            <span v-if="data.type==='order'">注文を確定しますか？</span>
            <span v-else-if="data.type==='checkout'">お会計を確定しますか？</span>
            <span v-else-if="data.type==='called'">スタッフをお呼びしますか？</span>
          </div>
          <div :class="s.modalButtons">
              <button id="yesButton" v-if="data.type==='checkout'" @click="updateTableSessions()">確定</button>
              <button id="yesButton" v-else @click="createOrder()">確定</button>
              <button :class="s.no" id="noButton" @click="hideModal()">戻る</button>
          </div>
      </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    data: {
      require: true,
    },
  },
  data() {
    return {
      item: {},
      quantity: 1,
      tables: [],
      calledItem: [],
    };
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
    ...mapGetters('orderhistory', ['totalHistoryAmount']),
    isReadySubmit() {
      return Boolean(this.items.every((item) => item.value || item.name === 'building'));
    },
    cartItems() { 
      return this.cart.items;
    },
  },
  created() {
    this.getMenuItems();
  },
  methods: {
    hideModal(payload) {
      this.$store.dispatch('modal/contents/hideModal', payload === 'update' ? payload : null, { root: true });
    },
    getMenuItems() {
      this.axios({
        method: 'GET',
        url: 'v1/menuitem/get/list',
        params: {
          user_id: this.user.id,
          flags: [999],
        },
      })
        .then((response) => {
          this.calledItem = response.data.list.data;
          console.log('calledItem', this.calledItem);
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },

    createOrder() {
      if ((!this.cartItems || this.cartItems.length === 0) && this.data.type !== 'called') {
        alert('カートが空です。商品を追加してください。');
        return;
      }
      const uuid = localStorage.getItem('deviceUUID');
      const diningTableID = localStorage.getItem('diningTableID');

      if (!uuid || !diningTableID) {
        alert('デバイス情報またはテーブル情報が見つかりません。QRコードを再度読み込んでください。');
        return;
      }
      // 注文データ初期設定
      const data = {
        ordersData: {
          table_session_id: this.data.tableSessionID,
          dining_table_id: diningTableID,
          status: 1,
        },
        orderItemsData: {
          items: [],
        },
        user_id: this.user.id,
      };

      // スタッフ呼び出し時
      if (this.data.type === 'called') {
        data.orderItemsData.items = [{ id: this.calledItem[0].id, quantity: 1 }]; //スタッフ呼び出しメニュー ID
      } else {
        // 通常注文時
        data.orderItemsData.items = this.cartItems.map((item) => ({
          id: item.id,
          quantity: item.quantity,
        }));
      }
      this.axios({
        method: 'POST',
        url: '/v1/order/create',
        data,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
          if (this.data.type === 'called') {
            const audio = new Audio('/sound/staff_calling.mp3');
            audio.play();
            this.hideModal();
            this.$router.push('/staff-called');
          } else {
            // ★ 飲み放題タイマーを開始
            this.$store.dispatch('cart/startDrinkPlanTimer', null, { root: true });
            //localstoregeがあれば合計金額を加算
            this.$store.dispatch('cart/transferCartToOrderHistory', { root: true });
            const audio = new Audio('/sound/thanks_to_order.mp3');
            audio.play();
            this.hideModal();
            this.$router.push('/order-complete');
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        })
        .finally(() => {
        });
    },

    addToCart(item) {
      const existingItem = this.cart.items.find((cartItem) => cartItem.id === item.id);
      if (existingItem) {
        for (let i = 0; i < this.quantity; i += 1) {
          this.addQuantity(existingItem.id);
        }
        this.hideModal();
      } else {
        const args = {
          id: item.id,
          quantity: this.quantity, // 既存の場合は更新された数量を使用
          price: item.price,
          label: item.label,
        };
        this.$store.dispatch('cart/addCart', args, { root: true });
        this.hideModal();
      }
    },

    addQuantity(id) {
      this.$store.dispatch('cart/addQuantity', id, { root: true });
    },

    updateTableSessions() {
      this.axios({
        method: 'POST',
        url: '/v1/tablesession/update',
        data: {
          id: this.data.tableSessionID,
          status: 1,
          user_id: this.user.id,
          total_amount: this.totalHistoryAmount,
        },
      })
        .then((res) => {
          console.log(res.data);
          this.$store.dispatch('cart/endSession', { root: true });
          this.hideModal();
          const audio = new Audio('/sound/thanks_to_visit.mp3');
          audio.play();
          this.$router.push('/checkout');
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },

  },
};
</script>

<style lang="scss" module="s">

/* モーダルの内容 */
.modalContent {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #DDD4C1;
  outline: none;
  padding: 5vw 5vw;
  font-family: '游明朝体', 'Yu Mincho', 'ヒラギノ明朝 ProN', 'Hiragino Mincho ProN', serif;
}

.modalContent .title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.modalButtons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}


.modalButtons button {
  background-color: #dc3545;
  color: white;
  border: none;
  width: 10vw;
  padding: 10px 20px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.modalButtons button:hover {
  background-color: #c82333;
}

.modalButtons button.no {
  background-color: gray;
  /* いいえボタンは赤色 */
}

.modalButtons button.no:hover {
  background-color: rgb(78, 78, 78);
}

@media (max-width: 768px) {
  .modalContent .title {
    font-size: 1.2rem; /* モバイルでのフォントサイズ */
  }

  .modalButtons button {
    width: 80%; /* 幅を大きく */
    margin: 10px 10px; /* 上下マージン */
    font-size: 1.2rem; /* フォントサイズを大きく */
  }
}
</style>
